import React, { Component } from 'react';
import $ from "jquery";
import PdfViewer from './PdfViewer';

class ReportReserveInvoiceModal extends Component {

    componentDidMount() {
        this.closeAction();
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#reportReserveInvoiceModal').on('hidden.bs.modal', function () {
            cleanData();
        });
    };

    render() {
        const {
            ReportsModel,
            ChangeInitialDate,
            ChangeFinalDate,
            ActualDate,
            ListReports,
            ShowPDFViewer,
            TypeDoc,
            CleanReportModel,
            MailTools,
            ChangeStatus,
            sucursales,
            ChangeSucursal,
            printhide,
            ShowFormatToPrint,
            GetReserveInvoicesReport,
            CloseReportReserveInvoiceModal
        } = this.props
        return (
            <div className="modal fade" id="reportReserveInvoiceModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="reportSalesSellerModalLabel" aria-hidden="true" >
                <div className="modal-dialog modal-lg modal-dialog-centered" >
                    <div className="modal-content">
                        <div className="modal-header" style={{ background: "#343a40" }}>
                            <h5 style={{ color: "white" }}>Facturas de reserva</h5>
                            <button type="button" className="close" onClick={() => { CleanReportModel(); CloseReportReserveInvoiceModal() }} aria-label="Close" style={{ color: "white" }} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="mt-2 ml-3">

                                <div className='row'>

                                    <div className='col-12 col-md-6'>
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><strong>Desde: </strong></span>
                                            </div>
                                            <input
                                                type="date"
                                                className="form-control"
                                                max={ActualDate}
                                                value={ReportsModel && ReportsModel.InitialDate}
                                                onChange={(event) => ChangeInitialDate(event)}
                                                onKeyDown={(ev) => {
                                                    if (ev.key === 'Enter') {
                                                        GetReserveInvoicesReport()
                                                    }
                                                }}

                                            />
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6'>
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><strong>Hasta: </strong></span>
                                            </div>
                                            <input
                                                type="date"
                                                className="form-control"
                                                max={ActualDate}
                                                value={ReportsModel && ReportsModel.FinalDate}
                                                onChange={(event) => ChangeFinalDate(event)}
                                                onKeyDown={(ev) => {
                                                    if (ev.key === 'Enter') {
                                                        GetReserveInvoicesReport()
                                                    }
                                                }}

                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-12 col-md-6'>
                                        <div className="input-group mt-3">
                                            <div className='input-group-prepend'>
                                                <span className='input-group-text'><strong>Sucursal:</strong></span>
                                            </div>
                                            <select
                                                name="select"
                                                className="form-control"
                                                value={ReportsModel.Sucursal}
                                                onChange={event => ChangeSucursal(event, false)}
                                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                            >
                                                <option value="---">Selecciona</option>
                                                {!!sucursales && sucursales.map(sucursal => {
                                                    return (
                                                        <option value={sucursal.code}>{`${sucursal.nombre}`}</option>
                                                    )
                                                })}
                                            </select>
                                        </div>

                                    </div>
                                    <div className='col-12 col-md-6'>
                                        <div className="input-group mt-3">
                                            <div className='input-group-prepend'>
                                                <span className='input-group-text'><strong>Estatus:</strong></span>
                                            </div>
                                            <select
                                                name="select"
                                                className="form-control"
                                                value={ReportsModel.Status}
                                                onChange={event => ChangeStatus(event)}
                                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                            >
                                                <option value="---">Todos</option>
                                                <option value="O">Pendientes</option>
                                                <option value="C">Entregados</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => { CleanReportModel(); CloseReportReserveInvoiceModal() }}
                            >
                                Cancelar
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => GetReserveInvoicesReport()}>
                                Generar
                            </button>

                        </div>
                    </div>
                </div>

                <PdfViewer
                    DocsToPrint={ListReports}
                    TypeDoc={TypeDoc}
                    EnableEditButton={false}
                    Editable={false}
                    ChangeEditableMode={false}
                    EditableDocModel={'SalesTools.EditableDocModel'}
                    RefreshDocModel={'SalesTools.RefreshDocModel'}
                    SaveChanges={'SalesTools.SaveChangesOrderInvoice'}
                    UploadDoc={'SalesTools.UploadInvoice'}
                    EditParam1={false}
                    ShowPDFViewer={() => { ShowPDFViewer(); CleanReportModel(); }}
                    user={'user'}
                    Counter={true}
                    MailTools={MailTools}
                    ReportsModel={ReportsModel}
                    printhide={printhide}
                    ShowFormatToPrint={ShowFormatToPrint}
                    reprint={false}
                />

            </div>
        );
    }
}

export default ReportReserveInvoiceModal;